import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const UpdateOverageExceptionLocationAPI = async (
  params: {
    osdNumber: number;
    exceptionLocation: string;
  },
) => {
  try {
    const url = `${getUrl(ApiType.UPDATE_EXCEPTION_LOCATION).replace(
      ":osdNumber",
      params.osdNumber.toString()
    )}`;
    const response = await axios.put(url, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateExceptionLocationError);
  }
};
